var module = angular.module('octopusApp.shared');

module.directive('selectMachines', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            placeholder: "@",
            available: "=",
            selected: "="
        },
        templateUrl: 'areas/shared/views/select-machines.html',
        controller: function(targetStateMapper) {
            var vm = this;
            vm.updateModelsWithProvided = updateModelsWithProvided;
            vm.onRemoved = onRemoved;
            vm.onSelected = onSelected;
            vm.calculateTargetIcon  = targetStateMapper.calculateTargetIcon;

            function onRemoved(item) {
                var itemIndex = vm.selected.indexOf(item.Id);
                vm.selected.splice(itemIndex, 1);
            }

            function onSelected(item){
                vm.selected.push(item.Id);
            }

            function updateModelsWithProvided() {
                vm.selectedModels = (vm.available || []).filter(function(machine) {
                    return (vm.selected || []).indexOf(machine.Id) !== -1;
                });
            }
        },
        controllerAs: 'vm',
        bindToController: true,
        link: function($scope) {
            $scope.$watch(function(){ return $scope.vm.selected; }, $scope.vm.updateModelsWithProvided);
            $scope.$watch(function(){ return $scope.vm.available; }, $scope.vm.updateModelsWithProvided);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/select-machines.js
// module id = 4713606446140661
// module chunks = 1